module.exports = __webpack_public_path__ + "static/965f6660bacee2157dfe86d2a37b27e178cb9b8e5ea17121cc0e2a57ad1e0de8-89006e14db6733c8b37ad8cbbfe3cc50.png";